const initialExp = {
  phone: /^\+?[1-9]?[0-9]?(?:[ -]?\d){0,14}$/,
  mail: /^[a-zA-Z0-9_.-]*[@]{0,1}[a-zA-Z0-9-]*[.]{0,1}[a-zA-Z0-9-.]*$/,
  driving_license: /^[0-9]{0,5}[/]?[0-9]{0,2}[/]?[0-9]{0,5}$/,
  postalCode: /^[0-9]{0,2}[-]?[0-9]{0,3}$/,
  passport: /^[A-Za-z0-9\s-]{0,15}$/,
  ID_card: /^[A-z]{0,3}[0-9]{0,6}$/,
  nip: /^[1-9][0-9]{0,9}$/,
  pesel: /^[0-9]{0,11}$/,
  expiryDate: /^([0-9]{0,2})\/?([0-9]{0,2})$/,
  cartNumber: /^[0-9]{0,19}$/,
  cvv: /^[0-9]{0,4}$/,
}

const finalExp = {
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*()_+-=[\]{};'\\:"|,./<>?]).{8,}$/,
  phone: /^\+?[1-9][0-9](?:[ -]?\d){7,14}$/,
  mail: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
  driving_license: /^[0-9]{5}[/]?[0-9]{2}[/]?[0-9]{5}$/,
  postalCode: /^[0-9]{2}[-]?[0-9]{3}$/,
  passport: /^[A-Za-z0-9\s-]{3,15}$/,
  ID_card: /^[A-z]{3}[0-9]{6}$/,
  nip: /^[1-9]([0-9]{9})$/,
  pesel: /^[0-9]{11}$/,
  expiryDate: /^(0[1-9]|1[0-2])\/?([0-9]{2})$/,
  cartNumber: /^[0-9]{13,19}$/,
  cvv: /^[0-9]{3,4}$/,
}

const CARD_TYPE = {
  drivingLicense: 'driving_license',
  passport: 'passport',
  idCard: 'ID_card',
}

const passwordErrorMessage = (p = '', t) => {
  if (p.length < 8) return errorMessage(t, 8 - p.length)
  else if (p.match(finalExp.password)) return false

  let warn = ''
  if (!p.match(/^(?=.*?[A-Z]).*$/)) warn += t('lowercaseLetter')
  if (!p.match(/^(?=.*?[a-z]).*$/)) warn += (warn ? ', ' : '') + t('uppercaseLetter')
  if (!p.match(/^(?=.*?[0-9]).*$/)) warn += (warn ? ', ' : '') + t('number')
  if (!p.match(/^(?=.*?[#?!@$%^&*-]).*$/)) warn += (warn ? ', ' : '') + t('symbol')
  return `${t('missing')}: ${warn}`
}

const isValidPesel = (pesel = '') => {
  if (typeof pesel !== 'string' || pesel.length !== 11) return false

  const controlNumber = Number(pesel[10])
  const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3]
  const sum = weight.reduce((r, e, i) => r += (Number(pesel[i]) * e), 0)

  return (10 - (sum % 10)) % 10 === controlNumber
}

const isValidNip = (nip = '') => {
  if (typeof nip !== 'string' || !nip.match(/^[0-9]{10}$/)) return false

  const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7]
  const sum = weight.reduce((r, e, i) => r + Number(nip[i]) * e, 0)

  return sum % 11 === Number(nip[9])
}

const isValidExpiry = (date = '') => {
  const [month, year] = date.split('/')
  const monthNum = Number(month)
  if (monthNum < 1 || monthNum > 12) return false

  const now = new Date()
  const expiry = new Date(`20${year}`, month)

  return expiry > now
}

const isValidCardNumber = (number) => {
  if (typeof number !== 'string' || number.length < 13 || number.length > 19) return false
  const digits = number.replace(/\D/g, '')
  let sum = 0
  let shouldDouble = false

  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = parseInt(digits[i])

    if (shouldDouble) {
      digit *= 2
      if (digit > 9) digit -= 9
    }

    sum += digit
    shouldDouble = !shouldDouble
  }

  return sum % 10 === 0
}

const errorMessage = (t, n = 1) => `${n} ${t(n === 1 ? 'characterIsMissing' : 'charactersAreMissing')}`

export { initialExp, finalExp, CARD_TYPE, passwordErrorMessage, isValidPesel, isValidNip, isValidCardNumber, isValidExpiry, errorMessage }